// Rails の config/locales を i18n-js で書き出したもの（app/frontend/locales/*.json。bin/rails i18n:export）を使う。
// キーは Rails と同じ: t("members.mypage.activities")、t("layouts.application.title_with_suffix", { title })
import { I18n, type TranslateOptions } from 'i18n-js'
import en from '@/locales/en.json'
import ja from '@/locales/ja.json'

export const i18n = new I18n({ ...ja, ...en })
i18n.defaultLocale = 'ja'
i18n.enableFallback = true

export function t(key: string, options?: TranslateOptions): string {
  return i18n.t(key, options)
}

const escape = (value: unknown) =>
  String(value).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]!)

/** HTML として描画する値（t_html の補間でエスケープしない）。Rails の html_safe 相当 */
export class SafeHtml {
  constructor(readonly html: string) {}
}

/**
 * *_html の訳語（Rails の t("..._html") と同じ扱い）。訳語そのものは HTML として、補間する値はエスケープして埋め込む。
 * <Html html={tHtml("members.mypage.delivery_information_html", { user: name, number })} />
 */
export function tHtml(key: string, values: Record<string, unknown> = {}): string {
  const safe = Object.fromEntries(
    Object.entries(values).map(([k, v]) => [k, v instanceof SafeHtml ? v.html : escape(v)]),
  )
  return i18n.t(key, safe)
}

/** <a> タグを SafeHtml として作る（tHtml の補間用。Rails の link_to 相当） */
export function linkHtml(href: string, text: string, { newTab = false } = {}): SafeHtml {
  const target = newTab ? ' target="_blank"' : ''
  return new SafeHtml(`<a href="${escape(href)}"${target}>${escape(text)}</a>`)
}
